export const BASE_URL = process.env.BASE_URL || 'http://localhost:8091';
// export const OAUTH_URL = process.env.VUE_APP_OAUTH_URL || 'http://localhost:8080/auth';
export const OAUTH_URL = window.CONFIG?.VUE_APP_OAUTH_URL || process.env.VUE_APP_OAUTH_URL;
export const OAUTH_REALM = window.CONFIG?.VUE_APP_OAUTH_REALM || process.env.VUE_APP_OAUTH_REALM;
export const OAUTH_CLIENT_ID = window.CONFIG?.VUE_APP_OAUTH_CLIENT_ID || process.env.VUE_APP_OAUTH_CLIENT_ID;
export const VUE_APP_BANKING_URL = window.CONFIG?.VUE_APP_BANKING_URL || process.env.VUE_APP_BANKING_URL;
export const VUE_APP_SITE_SUITE_URL = window.CONFIG?.VUE_APP_SITE_SUITE_URL || process.env.VUE_APP_SITE_SUITE_URL;
